import { Component, computed, inject } from '@angular/core';
import { AppSettings } from '../../services/app.settings';
import { MatDialog } from '@angular/material/dialog';
import { HelpComponent } from '../../pages/help/help.component';
import { ThemingService } from 'src/app/services/theming.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AppstateService } from 'src/app/services/appstate.service';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { MsalService } from '@azure/msal-angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  public appTitle = AppSettings.appTitle;
  public appVersion = this.appsettings.appVersion;

  public authService: AuthService = inject(AuthService);
  public userService: UserService = inject(UserService);

  public showChips = computed(() => (this.authService.isAuthenticated() && this.userService.isAuthorized()));
  public logoWidth = computed(() => (this.appStateService.sidenavExpanded() ? '235px' : '0px'))
  public logoMarginLeft = computed(() => (this.appStateService.sidenavExpanded() ? '0px' : '14px'))
  public logoMarginRight = computed(() => (this.appStateService.sidenavExpanded() ? '7px' : '22px'))
  public logoOpacity = computed(() => (this.appStateService.sidenavExpanded() ? '100' : '0'))

  constructor(public navigationService: NavigationService,
    public appStateService: AppstateService,
    private themingService: ThemingService,
    private dialog: MatDialog,
    public msalService: MsalService,
    public appsettings: AppSettings,
    public dataService: DataService
  ) {

  }

  toggleTheme(): void {
    this.themingService.toggleTheme();
  }

  openHelp(modus: number) {
    let dialog = this.dialog.open(HelpComponent);
    dialog.componentInstance.modus = modus;
  }

  openHandbuch() {
    window.open('../assets/handbuch/BAT-Handbuch.pdf', '_blank');
  }

  logout() {
    this.msalService.logout();
    this.msalService.instance.clearCache();
    this.msalService.instance.setActiveAccount(null);
  }

  login() {
    this.msalService.loginRedirect();
  }

  isLoggedin() {
    return this.msalService.instance.getActiveAccount() != null;
  }

  isTestMode() {
    return AppSettings.production === false;
  }

  setTestRole(role: string | null) {
    this.appsettings.testRole = role;
    this.userService.initUserinfo();

    //window.location.reload();
  }

  getIconName(role: string): string {
    if (this.appsettings.testRole === role)
      return 'check_circle';

    else
      return "person";
  }
  setStyle(style: string) {
    if (style === 'default') {
      document.documentElement.style.setProperty('--standardGap', '8px');
      document.documentElement.style.setProperty('--standardPadding', '8px');
      document.documentElement.style.setProperty('--standardCornerRadius', '8px');
      document.documentElement.style.setProperty('--standardFormPadding', '12px');
    } else if (style === 'flat') {
      document.documentElement.style.setProperty('--standardGap', '0px');
      document.documentElement.style.setProperty('--standardPadding', '0px');
      document.documentElement.style.setProperty('--standardCornerRadius', '0px');
      document.documentElement.style.setProperty('--standardFormPadding', '4px');
    } else if (style === 'halfflat') {
      document.documentElement.style.setProperty('--standardGap', '4px');
      document.documentElement.style.setProperty('--standardPadding', '4px');
      document.documentElement.style.setProperty('--standardCornerRadius', '4px');
      document.documentElement.style.setProperty('--standardFormPadding', '8px');
    }
  }

  ExecuteTest(test: string) {
    if (test === 'DeleteToken') {
      const authInfo = this.authService.authInfo();
      if (authInfo) {
        authInfo.accessToken = 'deletedToken';
      }
    } else if (test === 'NewToken') {
      this.authService.setAuthInfo().then(() => {
        console.log('New token set');
      });
    } else if (test === 'graphmail') {
      this.dataService.postTest('graphmail');
    }
  }
}
